const mutations = {
    SUBSCRIPTION_LOADING: (state) => {
        state.subscriptionStatus = 'loading';
    },
    SUBSCRIPTION_SUCCESS: (state, data) => {
        state.subscriptionStatus = 'success';
        Vue.set(state, 'subscriptions', data);
    },
    SUBSCRIPTION_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.subscriptionStatus = 'error';
        state.subscriptionErrors.record(errors);
    },
    CLEAR_SUBSCRIPTION_ERRORS: (state) => {
        state.subscriptionStatus = '';
        state.subscriptionErrors.clear();
    },
    CLEAR_PAYMENT_ERRORS: state => {
        state.paymentStatus = "";
        state.paymentErrors.clear();
    },
    PAYMENT_LOADING: state => {
        state.paymentStatus = "loading";
    },
    PAYMENT_SUCCESS: state => {
        state.paymentStatus = "success";
    },
    PAYMENT_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};
        console.log(errors);
        state.paymentStatus = "error";
        state.paymentErrors.record(errors);
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
